import { FileText } from 'lucide-react';
import { Button } from '@/core/components/ui/button';

interface GridEmptyStateProps {
  onRefresh?: () => void;
  title?: string;
  description?: string;
}

/**
 * Empty state component for the kiosk sessions grid
 * Displayed when no session data is available
 */
export const GridEmptyState = ({ 
  onRefresh,
  title = "No Sessions Found",
  description = "No kiosk sessions match your current filters. Try adjusting your date range or location filter."
}: GridEmptyStateProps) => {
  return (
    <div className="w-full border rounded-md">
      <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
        <div className="bg-gray-100 rounded-full p-4 mb-4">
          <FileText className="h-8 w-8 text-gray-400" />
        </div>
        
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {title}
        </h3>
        
        <p className="text-gray-600 mb-6 max-w-md">
          {description}
        </p>
        
        {onRefresh && (
          <Button 
            onClick={onRefresh} 
            variant="outline"
            className="flex items-center space-x-2"
          >
            <span>Refresh Data</span>
          </Button>
        )}
        
        <div className="mt-6 text-xs text-gray-500">
          <p>Tip: Try expanding your date range or removing location filters</p>
        </div>
      </div>
    </div>
  );
};